/**
 * Application constants and configuration
 */

// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE ?? "/api/v1",
  MOCK_MODE: true,
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
} as const;

// UI Constants
export const UI_CONFIG = {
  // Card dimensions
  CARD_WIDTHS: {
    PORTRAIT_DEFAULT: 168,
    WIDE_DEFAULT: 280,
  },
  
  // Animation durations (in ms)
  ANIMATION_DURATION: {
    FAST: 150,
    MEDIUM: 300,
    SLOW: 500,
  },
  
  // Breakpoints
  BREAKPOINTS: {
    MOBILE: 768,
    TABLET: 1024,
    DESKTOP: 1440,
  },
  
  // Pagination
  PAGE_SIZES: {
    DEFAULT: 20,
    SMALL: 10,
    LARGE: 50,
  },
  
  // Search
  SEARCH: {
    MIN_QUERY_LENGTH: 2,
    MAX_QUERY_LENGTH: 100,
    DEBOUNCE_DELAY: 300,
  },
  
  // Toast notifications
  TOAST: {
    DEFAULT_DURATION: 2800,
    MAX_TOASTS: 5,
  },
} as const;

// Validation Rules
export const VALIDATION = {
  PASSWORD: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 128,
  },
  
  NAME: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 50,
  },
  
  EMAIL: {
    MAX_LENGTH: 254,
  },
  
  GAME_ID: {
    MIN_LENGTH: 1,
    MAX_LENGTH: 50,
  },
} as const;

// App Metadata
export const APP_META = {
  NAME: "GameStore",
  VERSION: "1.0.0",
  DESCRIPTION: "Your premier destination for web games",
  KEYWORDS: ["games", "webgl", "browser", "gaming", "store"],
} as const;

// OAuth Providers
export const OAUTH_PROVIDERS = [
  { id: "google", icon: "🇬", label: "Continue with Google" },
  { id: "apple", icon: "🍎", label: "Continue with Apple" },
  { id: "facebook", icon: "📘", label: "Continue with Facebook" },
] as const;

// Game Categories
export const GAME_CATEGORIES = {
  GENRES: [
    "Action", "RPG", "Strategy", "Racing", "Platformer",
    "Puzzle", "Adventure", "Shooter", "Roguelite",
    "Battle Royale", "Sci-Fi", "Fantasy", "Stealth", "Thriller",
  ] as const,
  
  PLATFORMS: ["PC", "PS5", "Xbox", "Mobile"] as const,
  
  PRICE_FILTERS: ["All", "Free", "Paid", "On Sale"] as const,
  
  SORT_OPTIONS: ["rating", "reviews", "price-asc", "price-desc", "newest"] as const,
} as const;

// Storage Keys
export const STORAGE_KEYS = {
  WISHLIST: "gs-wishlist",
  AUTH_TOKEN: "gs-auth-token",
  USER_PREFERENCES: "gs-user-prefs",
  RECENTLY_VIEWED: "gs-recently-viewed",
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK: "Network error. Please check your connection and try again.",
  GENERIC: "An unexpected error occurred. Please try again.",
  VALIDATION: "Please check your input and try again.",
  AUTH: "Authentication failed. Please check your credentials.",
  NOT_FOUND: "The requested resource was not found.",
  SERVER_ERROR: "Server error. Please try again later.",
} as const;
